module.exports = __webpack_public_path__ + "img/Group 427320646.14d75ed9.png";